import React, { useEffect, useState } from 'react';
import './App.css';
import { Phone, MapPin, Clock } from 'lucide-react';
import heroImage from './assets/images/PH-20260130-0300.jpg';
import aboutImage from './assets/images/PH-20260130-0242.jpg';
import moodboardImageOne from './assets/images/PH-20260130-0219-2.jpg';
import moodboardImageTwo from './assets/images/PH-20260130-0300.jpg';
import moodboardImageThree from './assets/images/PH-20260130-0297.jpg';
import moodboardImageFour from './assets/images/PH-20260130-0214.jpg';

export default function App() {
  const [submissionState, setSubmissionState] = useState('idle'); // 'idle' | 'confirmed' | 'error'
  const [termsOpen, setTermsOpen] = useState(false);

  const handleAppointmentSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    try {
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString(),
      });
      if (response.ok) {
        setSubmissionState('confirmed');
        form.reset();
      } else {
        setSubmissionState('error');
        console.error('Form submission failed with status:', response.status);
      }
    } catch (error) {
      setSubmissionState('error');
      console.error('Form submission failed:', error);
    }
  };

  useEffect(() => {
    if (submissionState !== 'confirmed' && submissionState !== 'error') return undefined;
    const timeout = setTimeout(() => {
      setSubmissionState('idle');
    }, 7000);
    return () => clearTimeout(timeout);
  }, [submissionState]);

  return (
    <div className="site">
      <link
        href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600&family=Manrope:wght@300;400;500&display=swap"
        rel="stylesheet"
      />

      <header className="nav">
        <div className="nav-inner">
          <a className="brand" href="#home">Pedicurepraktijk Jagersveld</a>
          <nav className="nav-links">
            <a href="#behandelingen">Behandelingen</a>
            <a href="#over">Over</a>
            <a href="#contact">Contact</a>
          </nav>
          <a className="nav-cta" href="#afspraak">Afspraak</a>
        </div>
      </header>

      <main>
        <section id="home" className="hero">
          <div
            className="hero-image"
            style={{ backgroundImage: `url(${heroImage})` }}
            aria-hidden="true"
          />
          <div className="hero-overlay" aria-hidden="true" />
          <div className="hero-content">
            <div className="hero-title">Pedicurepraktijk Jagersveld</div>
            <div className="hero-text">
              Rustige, professionele voetverzorging in een mooie omgeving.
            </div>
            <a className="hero-button" href="#afspraak">Maak een afspraak</a>
          </div>
        </section>

        <section id="behandelingen" className="section treatments">
          <div className="section-inner">
            <div className="section-title">Behandelingen</div>
            <p className="section-lead">
              Je kunt kiezen uit drie behandelingen, afgestemd op jouw wensen.
            </p>
            <div className="treatment-grid">
              <article className="treatment-card">
                <h3>De basis pedicurebehandeling</h3>
                <p className="treatment-price">€ 40,-</p>
                <div className="treatment-description">
                  <p>
                    Bij deze behandeling worden je nagels geknipt, de nagelomgeving gereinigd, eelt, kloven of
                    likdoorns verwijderd en eventuele schimmelnagels behandeld.
                  </p>
                  <p>
                    Ter afsluiting krijg je een korte massage met olie of creme (naar keuze). Duur van de
                    behandeling is 45 minuten.
                  </p>
                </div>
                <details className="treatment-details-mobile">
                  <summary>Meer informatie</summary>
                  <p>
                    Bij deze behandeling worden je nagels geknipt, de nagelomgeving gereinigd, eelt, kloven of
                    likdoorns verwijderd en eventuele schimmelnagels behandeld.
                  </p>
                  <p>
                    Ter afsluiting krijg je een korte massage met olie of creme (naar keuze). Duur van de
                    behandeling is 45 minuten.
                  </p>
                </details>
              </article>
              <article className="treatment-card">
                <h3>Uitgebreide pedicurebehandeling</h3>
                <p className="treatment-price">€ 55,-</p>
                <div className="treatment-description">
                  <p>
                    Een basisbehandeling met daarbij een scrubbehandeling en uitgebreidere voetmassage.
                  </p>
                  <p>Duur van deze behandeling is 60 minuten.</p>
                </div>
                <details className="treatment-details-mobile">
                  <summary>Meer informatie</summary>
                  <p>
                    Een basisbehandeling met daarbij een scrubbehandeling en uitgebreidere voetmassage.
                  </p>
                  <p>Duur van deze behandeling is 60 minuten.</p>
                </details>
              </article>
              <article className="treatment-card">
                <h3>Korte behandeling</h3>
                <p className="treatment-price">€ 30,-</p>
                <div className="treatment-description">
                  <p>
                    Mocht er een probleemzone zijn, bijvoorbeeld een likdoorn, veel eelt, kloven of een ingroeiende
                    nagel, dan kun je voor deze behandeling kiezen.
                  </p>
                  <p>
                    In de behandeling wordt dit probleem aangepakt. Duur van deze behandeling is 20 minuten.
                  </p>
                </div>
                <details className="treatment-details-mobile">
                  <summary>Meer informatie</summary>
                  <p>
                    Mocht er een probleemzone zijn, bijvoorbeeld een likdoorn, veel eelt, kloven of een ingroeiende
                    nagel, dan kun je voor deze behandeling kiezen.
                  </p>
                  <p>
                    In de behandeling wordt dit probleem aangepakt. Duur van deze behandeling is 20 minuten.
                  </p>
                </details>
              </article>
              <article className="treatment-card">
                <h3>Nagels lakken (i.c.m. pedicurebehandeling)</h3>
                <p className="treatment-price">€ 17,50</p>
                <div className="treatment-description">
                  <p>
                    Ik werk met nagellakken van Depend. De nieuwe O2-formule laat circa 30% meer zuurstof door dan
                    traditionele nagellak. Dat ondersteunt de kwaliteit van de natuurlijke nagel.
                  </p>
                  <p>
                    De lak is vrij van 5 schadelijke chemicalien en geschikt voor mycosenagels. Lakken gaat in
                    3 stappen: basecoat, twee keer de gekozen kleurlaag en topcoat.
                  </p>
                  <p>
                    Bij keuze voor een Depend-lak krijg je het flesje mee naar huis. Vergeet niet je slippers
                    mee te nemen.
                  </p>
                </div>
                <details className="treatment-details-mobile">
                  <summary>Meer informatie</summary>
                  <p>
                    Ik werk met nagellakken van Depend. De nieuwe O2-formule laat circa 30% meer zuurstof door dan
                    traditionele nagellak. Dat ondersteunt de kwaliteit van de natuurlijke nagel.
                  </p>
                  <p>
                    De lak is vrij van 5 schadelijke chemicalien en geschikt voor mycosenagels. Lakken gaat in
                    3 stappen: basecoat, twee keer de gekozen kleurlaag en topcoat.
                  </p>
                  <p>
                    Bij keuze voor een Depend-lak krijg je het flesje mee naar huis. Vergeet niet je slippers
                    mee te nemen.
                  </p>
                </details>
              </article>
            </div>
            <p className="treatment-note">
              * Het verwijderen van nagellak voor aanvang van een behandeling wordt in rekening gebracht. De kosten
              hiervoor zijn € 15,-.
            </p>
          </div>
        </section>

        <section className="section moodboard">
          <div className="section-inner">
            <div className="moodboard-grid">
              <div className="moodboard-card">
                <img src={moodboardImageOne} alt="Persoonlijke aandacht in de praktijk" />
              </div>
              <div className="moodboard-card">
                <img src={moodboardImageTwo} alt="Behandeling in rustgevende sfeer" />
              </div>
              <div className="moodboard-card">
                <img src={moodboardImageThree} alt="Pedicurepraktijk Jagersveld" />
              </div>
              <div className="moodboard-card">
                <img src={moodboardImageFour} alt="Verzorgde omgeving" />
              </div>
            </div>
          </div>
        </section>

        <section id="over" className="section about">
          <div className="section-inner about-grid">
            <div>
              <div className="section-title">Over de praktijk</div>
              <p className="section-lead">
                Welkom bij mijn pedicurepraktijk in Lelystad, een plek waar persoonlijke aandacht en ontspanning
                centraal staan.
              </p>
              <p className="body-text">
                Mijn praktijk is aangesloten bij ProVoet, de brancheorganisatie voor pedicures. Je bent van harte
                welkom voor professionele voetverzorging, afgestemd op jouw wensen. Je kunt kiezen uit drie verschillende
                soorten behandelingen, zodat er altijd een passende optie voor je is.
              </p>
              <p className="body-text">
                De praktijk is gelegen in een rustige, groene omgeving en goed bereikbaar, met voldoende
                parkeergelegenheid. De ingang van de praktijk bevindt zich aan de zijkant van het huis.
              </p>
              <p className="body-text">
                Of het nu gaat om likdoorns, eelt, kloven, ingroeiende nagels of preventieve voetverzorging: je bent
                bij mij in goede handen. Met professionele kennis, moderne technieken en een warme, ontspannen sfeer
                zorg ik ervoor dat je niet alleen met klachtenvrije, maar ook met verzorgde en ontspannen voeten de
                deur uitgaat.
              </p>
              <p className="body-text signature-text">
                Graag tot binnenkort!<br />
                Femke Bonder
              </p>
              <a className="ghost-button" href="#afspraak">Plan je afspraak</a>
            </div>
            <div className="about-image">
              <img src={aboutImage} alt="Rustige pedicurebehandeling" />
            </div>
          </div>
        </section>

        <section id="afspraak" className="section appointment">
          <div className="section-inner appointment-card">
            <div>
              <div className="section-title">Afspraak maken</div>
              <p className="section-lead">
                Stuur je voorkeur, dan neem ik zo snel mogelijk contact met je op. Liever direct contact? App gerust via <a href="https://wa.me/31648355673" target="_blank" rel="noreferrer">WhatsApp</a>.
              </p>
            </div>
            <form className="appointment-form" onSubmit={handleAppointmentSubmit} name="afspraak" data-netlify="true">
              <input type="hidden" name="form-name" value="afspraak" />
              <label>
                Naam
                <input type="text" name="name" placeholder="Je naam" required />
              </label>
              <label>
                Telefoon
                <input type="tel" name="phone" placeholder="06 1234 5678" required />
              </label>
              <label>
                E-mail
                <input type="email" name="email" placeholder="naam@email.nl" required />
              </label>
              <label>
                Opmerkingen
                <textarea name="message" rows="4" placeholder="Je voorkeur voor dag en tijd" />
              </label>
              <button type="submit">Verstuur aanvraag</button>
            </form>
            {submissionState === 'confirmed' && (
              <div className="appointment-confirm" role="status" aria-live="polite">
                <span className="appointment-check" aria-hidden="true">
                  <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M7.5 12.3l3 3.1 6-6.2" />
                  </svg>
                </span>
                <span>Bedankt! Ik neem zo snel mogelijk contact met je op.</span>
              </div>
            )}
            {submissionState === 'error' && (
              <div role="alert" style={{ color: 'red', marginTop: '1rem' }}>
                Er is iets misgegaan. Probeer het opnieuw of neem contact op via WhatsApp.
              </div>
            )}
          </div>
        </section>

        <section id="contact" className="section contact">
          <div className="section-inner">
            <div className="section-title">Contact</div>
            <div className="contact-grid">
              <a className="contact-card" href="tel:+31648355673">
                <Phone />
                <div>
                  <strong>Telefoon</strong>
                  <span>06 4835 5673</span>
                </div>
              </a>
              <a
                className="contact-card"
                href="https://maps.google.com/?q=Jagersveld%2016%2C%208222%20AB%20Lelystad"
                target="_blank"
                rel="noreferrer"
              >
                <MapPin />
                <div>
                  <strong>Adres</strong>
                  <span>Jagersveld 16, 8222 AB Lelystad</span>
                </div>
              </a>
              <div className="contact-card contact-hours">
                <Clock />
                <div>
                  <strong>Openingstijden</strong>
                  <span>Maandag: 12:00 - 20:00</span>
                  <span>Donderdag: 12:00 - 20:00</span>
                  <span>Vrijdag: 12:00 - 17:00</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <p>© 2026 Pedicurepraktijk Jagersveld. Alle rechten voorbehouden.</p>
        <button type="button" className="terms-trigger" onClick={() => setTermsOpen(true)}>
          Algemene voorwaarden
        </button>
      </footer>

      {termsOpen && (
        <div className="terms-overlay" role="dialog" aria-modal="true" aria-label="Algemene voorwaarden">
          <div className="terms-modal">
            <div className="terms-header">
              <h2>Algemene voorwaarden</h2>
              <button type="button" className="terms-close" onClick={() => setTermsOpen(false)}>
                Sluiten
              </button>
            </div>
            <div className="terms-content">
              <p>
                Deze voorwaarden gelden voor iedere aanbieding, behandeling en transactie tussen Pedicurepraktijk
                Jagersveld en een client.
              </p>

              <h3>Inspanningen</h3>
              <p>
                Pedicurepraktijk Jagersveld zal de behandelingen naar beste inzicht en vermogen en overeenkomstig
                de eisen van goed vakmanschap uitvoeren en op grond van de op dat moment bekende stand der
                wetenschap. Pedicurepraktijk Jagersveld zal zo veel als redelijkerwijs mogelijk is de client
                inlichten over financiele consequenties van de wijziging of aanvulling van de behandeling.
              </p>

              <h3>Afspraken</h3>
              <p>
                De client moet verhindering voor een afspraak zo spoedig mogelijk, doch uiterlijk 24 uur
                voorafgaande aan de afspraak aan Pedicurepraktijk Jagersveld melden. Indien de client deze
                verplichting niet of niet tijdig nakomt, mag Pedicurepraktijk Jagersveld het gehele honorarium
                voor de afgesproken behandeling aan de client berekenen. Indien de client meer dan vijf minuten
                later dan de afgesproken tijd in de praktijk komt, mag Pedicurepraktijk Jagersveld de verloren
                tijd inkorten op de behandeling en toch het gehele afgesproken honorarium berekenen.
              </p>

              <h3>Betaling</h3>
              <p>
                Pedicurepraktijk Jagersveld vermeldt alle prijzen van behandeling en producten zichtbaar in de
                praktijk. De gemelde prijzen zijn inclusief BTW. Aanbiedingen in advertenties zijn geldig in de
                aangegeven looptijd en/of zolang de voorraad strekt. De client dient direct na afloop van de
                behandeling de betaling van de behandeling en eventuele producten contant of per pin te voldoen.
              </p>

              <h3>Persoonsgegevens en privacy</h3>
              <p>
                De client voorziet Pedicurepraktijk Jagersveld bij de eerste behandeling van alle gegevens
                (waaronder medische gegevens/ziektebeelden), waarvan Pedicurepraktijk Jagersveld aangeeft dat
                deze noodzakelijk zijn of waarvan de client redelijkerwijs behoort te begrijpen dat deze
                noodzakelijk zijn voor het zorgvuldig uitvoeren van de behandelingen. Pedicurepraktijk Jagersveld
                neemt de persoonlijke gegevens van de client op in een geautomatiseerd systeem en/of op een
                klantenkaart. Pedicurepraktijk Jagersveld behandelt de vertrouwelijke gegevens van de client
                volgens de richtlijnen in de Wet Bescherming Persoonsgegevens. Pedicurepraktijk Jagersveld zal
                gegevens van de client niet verkopen of verhuren aan derden zonder schriftelijke toestemming vooraf
                van de client.
              </p>

              <h3>Geheimhouding</h3>
              <p>
                Pedicurepraktijk Jagersveld is verplicht tot geheimhouding van alle vertrouwelijke informatie die
                de client heeft medegedeeld tijdens de behandeling. Informatie geldt als vertrouwelijk als dit
                door de client is medegedeeld of als dit voortvloeit uit de aard van de informatie. De
                geheimhouding vervalt indien, op grond van een wettelijke bepaling of een gerechtelijke
                uitspraak, Pedicurepraktijk Jagersveld verplicht is de vertrouwelijke informatie aan derden te
                verstrekken.
              </p>
              <p>
                Pedicurepraktijk Jagersveld is niet aansprakelijk voor schade, van welke aard dan ook, ontstaan
                doordat Pedicurepraktijk Jagersveld is uitgegaan van door de client verstrekte onjuiste en/of
                onvolledige informatie over relevante lichamelijke aandoeningen, medicijngebruik, werkzaamheden
                of vrijetijdsbesteding. Pedicurepraktijk Jagersveld is niet aansprakelijk voor beschadiging van
                persoonlijke eigendommen die de client heeft meegenomen naar de praktijk.
              </p>

              <h3>Beschadiging en diefstal</h3>
              <p>
                Pedicurepraktijk Jagersveld heeft het recht van de client een schadevergoeding te eisen indien de
                client meubilair, apparatuur of producten beschadigt. Pedicurepraktijk Jagersveld meldt diefstal
                altijd bij de politie.
              </p>

              <h3>Klachten</h3>
              <p>
                Indien de client een klacht heeft over de behandeling of een product, moet deze zo spoedig
                mogelijk, doch binnen vijf werkdagen na ontdekking schriftelijk gemeld worden aan
                Pedicurepraktijk Jagersveld. Pedicurepraktijk Jagersveld moet de klager binnen vijf werkdagen
                adequaat antwoord geven. Indien een klacht gegrond is, zal Pedicurepraktijk Jagersveld de
                behandeling opnieuw verrichten zoals overeengekomen, tenzij dit inmiddels voor de client
                aantoonbaar zinloos is geworden en de client dit schriftelijk kenbaar maakt.
              </p>
              <p>De garantie vervalt indien:</p>
              <ul>
                <li>De client andere producten heeft gebruikt dan door Pedicurepraktijk Jagersveld is geadviseerd.</li>
                <li>De client de adviezen niet heeft opgevolgd.</li>
                <li>De client de verwijzing naar andere disciplines (waaronder huisarts, podotherapeut) niet binnen twee werkdagen heeft opgevolgd.</li>
                <li>De client de producten niet volgens de gebruiksaanwijzing heeft gebruikt.</li>
              </ul>

              <h3>Behoorlijk gedrag</h3>
              <p>
                De client behoort zich in de praktijk behoorlijk te gedragen volgens algemeen aanvaarde normen.
                Indien de client na herhaaldelijke waarschuwingen onbehoorlijk gedrag blijft vertonen, heeft
                Pedicurepraktijk Jagersveld het recht de client toegang tot de praktijk te weigeren zonder opgaaf
                van redenen.
              </p>

              <h3>Recht</h3>
              <p>
                Op elke overeenkomst tussen Pedicurepraktijk Jagersveld en de client is Nederlands recht van
                toepassing. In geval van uitleg van de inhoud en strekking van deze algemene voorwaarden, is de
                Nederlandse tekst daarvan steeds bepalend. Van toepassing is steeds de laatst gedeponeerde versie
                c.q. de versie zoals die gold ten tijde van het totstandkoming van de overeenkomst.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
